<div class="date-picker-container">
  <input #datepicker type="text" [id]="'date-range-'+attribute" class="form-control"
    [attr.placeholder]="noRange ? 'No Date Range' : 'Select Date Range'" [attr.disabled]="noRange ? '' : null"
    readonly />
  <img class="calendar-icon" src="/assets/images/icon-calendar.svg" (click)="showDatePicker()" alt="Calendar Icon">
</div>
